






























import { defineComponent } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSpinner from "@/components/BaseSpinner";
import RichTextarea from "@/components/RichTextarea";

const REVIEW_CHARS_LIMIT = "1500";

export default defineComponent({
  name: "ReviewInput",
  components: { BaseIconButton, RichTextarea, BaseSpinner },
  props: {
    allowSend: { type: Boolean, required: true },
    value: { type: String, required: true },
    sending: { type: Boolean, default: false },
  },
  setup() {
    return {
      REVIEW_CHARS_LIMIT,
    };
  },
});
